/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'
import type { ScheduledMessages } from '../models/ScheduledMessages'

export class MessagingScheduledService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Emails and texts scheduled to send in the next day and week, and volunteer reminders waiting
     * to become emails. Cached, so the Helm page and monitors polling this share one count.
     * What's queued to go out later, counted when requested and cached for `cache_seconds` (15 minutes), so every caller shares one count. `counted_at` says when it was counted. Not recorded as a metric: what actually went out is in the `messaging_sent` metric.
     *
     * - `email` / `sms`: pending messages whose `send_on` is in the next 24 hours and the next 7 days (the week includes the day).
     * - `volunteer_reminders`: reminders the nightly volunteer reminder run (17:15 UTC) queued in the last 24 hours. `waiting` haven't been turned into emails yet; each becomes one email per volunteer scheduled in that role, and they're added to the email queue only as they're processed (75 a minute), so they never show in `email`. Before the nightly run this is the previous night's batch, mostly already sent.
     *
     * Example:
     * ```json
     * {
     * "data": {
     * "email": {"next_24_hours": 412, "next_7_days": 1046},
     * "sms": {"next_24_hours": 21980, "next_7_days": 74210},
     * "volunteer_reminders": {"waiting": 18240, "queued_last_24_hours": 24310, "organizations": 1903},
     * "counted_at": "2026-10-12T17:30:02Z",
     * "cache_seconds": 900
     * }
     * }
     * ```
     * @returns any OK
     * @throws ApiError
     */
    public getScheduledMessages(): CancelablePromise<{ data: ScheduledMessages }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/messaging/scheduled',
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
}
